import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
/**
* @class PositivePayCheckFile
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @property {STRING} _id - The account of the check.
* @extends BCMSRecord
* @example const record = model.positivePayCheckFiles[0];
* const profile = new PositivePayCheckFile(record);
*/
export default class PositivePayCheckFile extends BCMSRecord {
    _id
    _description

    constructor(record) {     
      super(record) 
    }
  }
  PositivePayCheckFile.define({
    "recordType": "positivePayCheckFiles",
    "recordIDProp":"id",
    "className" : "PositivePayCheckFile",
    "recordProperties":[
        /** 
         * @name id
         * @instance
         * @property get {STRING} - gets the id 
         * @property set {STRING} - sets the id 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("id","_id"),

        /** 
         * @name description
         * @instance
         * @property get {STRING} - gets the description 
         * @property set {STRING} - sets the description 
         * @memberof PositivePayCheck
         */
        BCMSRecordProperty.mapToString("description","_description"),
    ]  
})




